export class NotificationLabelEN {

    broadcast: {
        title: string;
        clearAll: string;
    }

    notification: {
        preapproval: string;
        online: string;
        broadcast: string;
    }

    preapproval: {
        title: string;
        loading: string;
        new: string;
        loaded: string;
        clear: string;
    }

    constructor() {

        this.broadcast = {
            title: "Broadcasted messages",
            clearAll: "Clear All"
        }
        this.notification = {
            preapproval: "Pre-Approval Notifications",
            online: "Online Customer Notifications",
            broadcast: "Broadcast Messages"
        }
        this.preapproval = {
            title: "Notification Center",
            loading: "Loading...",
            new: "No New Notifications",
            loaded: "Notifications are being loaded please wait.",
            clear: "Clear All"
        }
    }
}